import { type InputHTMLAttributes, type ReactNode, useId } from 'react';

import { cn } from '@/utils/cn';

import styles from './Field.module.css';

export interface CheckboxFieldProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: ReactNode;
  /** Second line under the label. */
  description?: ReactNode;
}

export function CheckboxField({
  label,
  description,
  id,
  className,
  ...inputProps
}: CheckboxFieldProps) {
  const generatedId = useId();
  const inputId = id ?? generatedId;

  return (
    <label htmlFor={inputId} className={cn(styles.checkbox, className)}>
      <input id={inputId} type="checkbox" className={styles.checkboxInput} {...inputProps} />
      <span className={styles.checkboxText}>
        <span>{label}</span>
        {description && <span className={styles.checkboxDescription}>{description}</span>}
      </span>
    </label>
  );
}
